import React from 'react'
import { FormattedMessage } from 'react-intl'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PersonIcon from '@material-ui/icons/Person'
import { Avatar, withStyles, Menu, IconButton, MenuItem } from '@material-ui/core'
import { useStyles } from './Styles'
import { useKeycloak } from '@react-keycloak/web'
import Configuration from '../../Services/Api/Configuration'
import CookiesStorageService from '../../Services/CookiesStorageService'
import { NamedRoutes } from '../../routes'

const UserMenu = ({ taxpayerData, userData, userPermissions, locale }) => {
  const classes = useStyles()
  const { keycloak } = useKeycloak()
  const [userEditMenuItems, setUserEditMenuItems] = React.useState([])
  const [anchorEl, setAnchorEl] = React.useState(null)
  const isMenuOpen = Boolean(anchorEl)
  const menuId = 'header-account-menu'

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const StyledMenu = withStyles((theme) => ({
    paper: {
      borderRadius: theme.spacing(0),
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0),
      textAlign: 'center',
      '& .MuiMenu-list': {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }
    }
  }))((props) => (
    <Menu
      elevation={2}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: locale === 'ar' ? 'left' : 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      {...props}
    />
  ))

  React.useEffect(() => {
      if (!!Object.keys(userData || {}).keys()) {
        let menu = [
          {
            key: 'profile',
            link: Configuration?.PROFILING_URL,
            name: <FormattedMessage id='UserMenu.Profile'
                                    values={{ name: locale === 'ar' ? `${userData?.first_name_ar} ${userData?.last_name_ar}` || `${userData?.first_name} ${userData?.last_name}` : `${userData?.first_name} ${userData?.last_name}` }}/>
          }
        ]
        if (parseInt(userData?.active_taxpayers || 0) > 1) {
          menu.push({
            key: 'selectCompany',
            link: `${Configuration?.PROFILING_URL}/selecttaxpayer?redirect_uri=${window.location.href.split('/')?.includes('invoices') ? window.location.origin + NamedRoutes.invoices : document.location.href}`,
            name: <FormattedMessage id='UserMenu.SelectCompany'/>
          })
        }
        setUserEditMenuItems(menu)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [userData])
  return (
    <>
      <IconButton
        edge="end"
        aria-label={<FormattedMessage id='UserMenu.label'/>}
        aria-controls={menuId}
        aria-haspopup="true"
        className={classes.userMenuButton}
        onClick={handleProfileMenuOpen}
        color="inherit"
      >
        <Avatar className={classes.userAvatar}>
          <PersonIcon/>
        </Avatar>
        <div className={classes.menuUserName}>
          {(!!Object.keys(userData || {}).length && !!Object.keys(taxpayerData || {}).length) ? (
            <>
              <strong>{locale === 'ar' ? taxpayerData?.name_ar || taxpayerData?.name : taxpayerData?.name}</strong>
              <span>{locale === 'ar' ? `${userData?.first_name_ar} ${userData?.last_name_ar}` || `${userData?.first_name} ${userData?.last_name}` : `${userData?.first_name} ${userData?.last_name}`}</span>
              {/*{!!userData?.email && <span>({userData?.email})</span>}*/}
            </>
          ) : <FormattedMessage id='UserMenu.username'/>}
        </div>
        <span>

        </span>
        <ExpandMoreIcon color="inherit"/>
      </IconButton>
      <StyledMenu
        id={menuId}
        anchorEl={anchorEl}
        keepMounted
        open={isMenuOpen}
        classes={{ paper: classes.userMenuPaper }}
        onClose={handleMenuClose}
      >
        {userEditMenuItems?.map((item, index) =>
          <MenuItem key={index} onClick={handleMenuClose}>
            <a href={item?.link}>{item?.name}</a>
          </MenuItem>
        )}
        <MenuItem className={'signOut'} onClick={() => {
          CookiesStorageService.clearTaxpayerTRN()
          keycloak.logout()
        }}><FormattedMessage
          id='UserMenu.button.logout'/></MenuItem>
      </StyledMenu>
    </>
  )
}

export default UserMenu
